import { formatDateTime, parseUtcMs } from "@/utils/datetime";
import { Text, type DataTableColumn } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { hatcheryTextModes } from "@/app/theme";
import type { EmbodimentTableRow } from "./EmbodimentTableRow";
import styles from "./EmbodimentPage.module.css";

// 정체성 facet 셀. 부품에서 파생한 단일 표시값이다(없으면 dash).
function identityCell(value: string | null): ReactNode {
  if (value === null || value === "") {
    return <span className={styles.labelEmpty}>-</span>;
  }
  return <Text variant={hatcheryTextModes["caption-normal"]}>{value}</Text>;
}

export const embodimentColumns: readonly DataTableColumn<EmbodimentTableRow>[] = [
  {
    key: "name",
    header: "이름",
    width: "minmax(220px, 1fr)",
    render: (row) => (
      <div className={styles.nameCell}>
        <div className={styles.nameText}>
          <Text variant={hatcheryTextModes["body-bold"]}>{row.name}</Text>
        </div>
      </div>
    ),
  },
  {
    key: "endEffectorName",
    header: "End effector",
    width: "150px",
    render: (row) => identityCell(row.endEffectorName),
  },
  {
    key: "modified_at",
    header: "수정일",
    width: "180px",
    format: (value) => formatDateTime(parseUtcMs(String(value))),
  },
];
